module.exports = __webpack_public_path__ + "static/img/66-1.3d754c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/66-1.jpg
// module id = Shqb
// module chunks = 0